module.exports = __webpack_public_path__ + "assets/manual_personalAccident-ebd2f09c887619551b617e13f36ea5cc.pdf";